import { useSearchParams } from "react-router-dom";
import { PENDING_APPOINTMENTS_HOMEPAGE_API } from "../enums/ApiPaths";
import {
  PENDING_APPOINTMENTS,
  PENDING_APPOINTMENTS_HOMEPAGE,
} from "../enums/QueryKeys";
import { useFetch } from "./Fetching";
import { pendingFilterValues } from "../features/admin/pendingAppointments/components/PendingAppointmentsFilter";

export default function usePendingAppointments() {
  const [searchParams] = useSearchParams();

  const pageNumber = Number(searchParams.get(pendingFilterValues.page)) || 0;
  const service = searchParams.get(pendingFilterValues.service) || "";
  const species = searchParams.get(pendingFilterValues.species) || "";
  const user = searchParams.get(pendingFilterValues.user) || "";
  const pet = searchParams.get(pendingFilterValues.pet) || "";
  var from = searchParams.get(pendingFilterValues.from) ?? "";
  var to = searchParams.get(pendingFilterValues.to) ?? "";

  if (String(from) === "Invalid Date") {
    from = "";
  }
  if (String(to) === "Invalid Date") {
    to = "";
  }

  let apiPath = `/appointments/pending/paging?page=${pageNumber}&from=${from}&to=${to}&serviceId=${service}&speciesId=${species}&userId=${user}&petId=${pet}`;

  const keys = [
    PENDING_APPOINTMENTS,
    pageNumber,
    to,
    from,
    service,
    species,
    user,
    pet,
  ];

  const { data, isLoading, error } = useFetch(apiPath, null, keys);

  return { data, error, isLoading };
}

export function useGetPendingAppointmentsLimit() {
  const { data, isLoading, error, refetch } = useFetch(
    PENDING_APPOINTMENTS_HOMEPAGE_API,
    null,
    PENDING_APPOINTMENTS_HOMEPAGE
  );
  const appointments = data?.appointments ?? [];
  const count = Number(data?.count) ?? 0;

  return { appointments, count, isLoading, error, refetch };
}
